import React from 'react'
import './BlarHeading.scss'

export default function BlarHeading(props) {
  const {
    slice
  } = props

  let title;

  if (slice.primary.titill[0].type === 'heading1') {
    title= <h1 className='blarHeading blarHeading__heading1'>{slice.primary.titill[0].text}</h1>
  } else if (slice.primary.titill[0].type === 'heading2') {
    title= <h2 className='blarHeading blarHeading__heading2'>{slice.primary.titill[0].text}</h2>
  } else if (slice.primary.titill[0].type === 'heading3') {
    title= <h3 className='blarHeading blarHeading__heading3'>{slice.primary.titill[0].text}</h3>
  } else if (slice.primary.titill[0].type === 'heading4') {
    title= <h4 className='blarHeading blarHeading__heading4'>{slice.primary.titill[0].text}</h4>
  } else if (slice.primary.titill[0].type === 'heading5') {
    title= <h5 className='blarHeading blarHeading__heading5'>{slice.primary.titill[0].text}</h5>
  } else if (slice.primary.titill[0].type === 'heading6') {
    title= <h6 className='blarHeading blarHeading__heading6'>{slice.primary.titill[0].text}</h6>
  } else {
    return null
  }

  return (
    <div style={{display: 'flex'}}>
      {title}
    </div>
  )
}